export const translationKeys = {
  confirmar: "Confirmar",
  cancelar: "Cancelar",
  modalConfirmTitle: "Confirmar cancelación",
  modalConfirmLine1: "¿Estás seguro que deseas cancelar tu postulación?",
  modalConfirmLine2:
    "Al confirmar, la postulación será cancelada y los datos cargados serán eliminados.",
};
